import script from "./SeatNumbers.vue?vue&type=script&setup=true&lang=js"
export * from "./SeatNumbers.vue?vue&type=script&setup=true&lang=js"

import "./SeatNumbers.vue?vue&type=style&index=0&id=d595aefe&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d595aefe"]])

export default __exports__